import './styles.scss';
import { FC } from 'react';
import { ModalTagInterface } from './indexModel';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IconX } from '@tabler/icons-react';
import Loading from '../../../../../../components/loading2';
import CustomInputController from '../../../../../../components/customInput/indexController';

const ModalTag: FC<ModalTagInterface> = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={() => props.hide(false)}
      aria-labelledby=""
      size="sm"
      centered={true}
      dialogClassName="modal-tag-component"
    >
      <Modal.Header>
        { props.type === 'ticket' &&
          <Modal.Title>
            { props.data?.id ? props.t('title_edit_tag_ticket') : props.t('title_new_tag_ticket') }
          </Modal.Title>
        }
        { props.type === 'consumer' &&
          <Modal.Title>
            { props.data?.id ? props.t('title_edit_tag_consumer') : props.t('title_new_tag_consumer') }
          </Modal.Title>
        }
        <div className="modal-tag-header-actions">
          <IconX onClick={() => props.hide(false)} />
        </div>
      </Modal.Header>
      <Modal.Body>
        { (!props.data || props.loadingEdit) && <Loading blur={true}/>}
        { props.data &&
          <>
          <div className="modal-tag-section">
            <div className="modal-tag-item">
              <div className="modal-tag-item-header">
                <span className="modal-tag-item-label">{props.t('form.name_label')}</span>
                <span className="modal-tag-item-label-required">*</span>
              </div>
              <CustomInputController 
                type='input'
                value={props.data?.name || ''}
                setCustomValue={props.setDataValue}
                placeholder={props.t('form.name_placeholder')}
                required={true}
                id={'name'}
                regexValueBlock={/[\s]/}
                inputLengthMax={50}
              />
              { props.data?.name?.length > 50 &&
                <span className="modal-tag-item-invalid-message">{props.t('form.name_alert_max')}</span>
              }
            </div>
          </div>
          <div className="modal-tag-section section-margin-top">
            <div className="modal-tag-section-status">
              <div className="modal-tag-section-status-info">
                <span className="modal-tag-section-status-title">{props.t('form.status_label')}</span>
                { props.type === 'ticket' &&
                  <span className="modal-tag-section-status-message">
                    {props.t(props.data.active ? 'form.status_tag_ticket_active' : 'form.status_tag_ticket_inactive')}
                  </span>
                }
                { props.type === 'consumer' &&
                  <span className="modal-tag-section-status-message">
                    {props.t(props.data.active ? 'form.status_tag_consumer_active' : 'form.status_tag_consumer_inactive')}
                  </span>
                }
              </div>
              <div className="modal-tag-section-status-switch">
                <div className="switch-input">
                  <div className="switch-input">
                    <OverlayTrigger overlay={<Tooltip>{props.data.active ? props.t('form.status_active') : props.t('form.status_inactive')}</Tooltip>}>
                      <label className="switch">
                        <input type="checkbox" checked={props.data.active} onChange={() => props.setDataValue('active', !props.data.active)} />
                        <span className="slider round"></span>
                      </label>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </>
        }
      </Modal.Body>
      <Modal.Footer>
        <button className='modal-tag-btn-cancel' onClick={() => props.hide(false)}>{props.t('btn_cancel')}</button>
        <button className='modal-tag-btn-save' disabled={!props.isValid() || props.loadingEdit} onClick={() => props.handleSubmit()}>
          { props.data?.id && props.t('btn_save')}
          { !props.data?.id && props.t('btn_create')}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTag;
